// extracted by mini-css-extract-plugin
export default {"typologyComponent":"_2c8QX01YfTcYcg1gxHXhMw","title":"_1w1c6B1-GNU_ust466pdIw","titleDetail":"_2p4-9MJCQEKlNtkuKrtxWz"};